//--- React
import { useEffect } from "react";
import { useDispatch } from "react-redux";
//--- Ant Design
import { Card, Col, Divider, Row, Select } from "antd";
//--- Project
import "../styles.css";
import PulseDateRange from "components/Common/DateRangeComponents/PulseDateRange";
import { setPageLoader } from "reducers/loaderSlice";
//--- Icon
import MARKET_PULSE_ICON from "../../../../assets/images/icons/MarketPulse.svg";
import REVIEW_COUNTS_ICON from "../../../../assets/images/icons/review_counts.png";
import POSITIVE_ICON from "../../../../assets/images/icons/positive-icon.svg";
import NEGATIVE_ICON from "../../../../assets/images/icons/negative-icon.svg";
import NEUTRAL_ICON from "../../../../assets/images/icons/neutral-icon.svg";
const CompanyFilter = ({
  selectedCompany,
  filterValue,
  setFilterValue,
  onFilterChange,
  companyReviewData,
  companiesList,
  companiesLoading,
  selectedSentiment,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageLoader(companiesLoading ? "refresh" : null));
  }, [dispatch, companiesLoading]);

  useEffect(() => {
    if (companiesList?.companies?.length > 0) {
      if (selectedCompany) {
        const selectedCompanyDetails = companiesList?.companies?.filter(
          (item) => item?.company === selectedCompany
        )?.[0];
        // onFilterChange("company", selectedCompanyDetails)
        setFilterValue({
          company: selectedCompanyDetails.company,
          minDate: selectedCompanyDetails.min_date * 1000,
          maxDate: selectedCompanyDetails.max_date * 1000,
          startDate: selectedCompanyDetails.min_date * 1000,
          endDate: selectedCompanyDetails.max_date * 1000,
          sourceList: null,
          bikeModel: null,
          sentiment: selectedSentiment || null,
        });
      } else {
        setFilterValue({
          company: companiesList.companies[0].company,
          minDate: companiesList.companies[0].min_date * 1000,
          maxDate: companiesList.companies[0].max_date * 1000,
          startDate: companiesList.companies[0].min_date * 1000,
          endDate: companiesList.companies[0].max_date * 1000,
          sourceList: null,
          bikeModel: null,
          sentiment: selectedSentiment || null,
        });
      }
    }
  }, [
    companiesList,
    setFilterValue,
    dispatch,
    selectedCompany,
    selectedSentiment,
  ]);

  return (
    <>
      <Card bordered={false} className="filter-box marketpulse-subheader-card">
      <Row gutter={[16, 16]} justify={"space-around"} className="mb05">
        <Col xs={24} sm={7} md={7} lg={7} xl={6}>
          <div className="lable">Company</div>
          <Select
            showSearch
            size="large"
            placeholder="Select a company"
            data-testid="market-company-dropdown"
            className="w100 mt05"
            value={filterValue.company}
            loading={companiesLoading}
            options={companiesList?.companies}
            fieldNames={{
              label: "company",
              value: "company",
              options: "options",
            }}
            onChange={(_, value) => onFilterChange("company", value)}
          />
        </Col>
        <Col xs={24} sm={7} md={10} lg={7} xl={6}>
          <div className="lable mb05">Date</div>
          <PulseDateRange
            dataTimeRange={[filterValue.minDate, filterValue.maxDate]}
            selectedTimeRange={[filterValue.startDate, filterValue.endDate]}
            onTimeFilterChange={(value) => onFilterChange("dates", value)}
          />
        </Col>
          <Col xs={24} sm={24} md={7} lg={10} xl={12} className="flex-end">
            <div className="review-count-box">
              <div className="reviews-container">
                <div className="review-info">
                  <div className="count">
                    {companyReviewData?.total_reviews || 0}
                  </div>
                  <div className="count">Reviews</div>
                </div>
              </div>

              <div className="sentiment-stats">
                <div className="sentiment-item ">
                  <img
                    src={POSITIVE_ICON}
                    alt="positive"
                    height={22}
                    width={22}
                  />
                  <span className="percentage">
                    {companyReviewData?.positive_percentage}%
                  </span>
                </div>

                <div className="sentiment-item ">
                  <img
                    src={NEGATIVE_ICON}
                    alt="negative"
                    height={22}
                    width={22}
                  />
                  <span className="percentage">
                    {companyReviewData?.negative_percentage}%
                  </span>
                </div>

                <div className="sentiment-item ">
                  <img
                    src={NEUTRAL_ICON}
                    alt="neutral"
                    height={22}
                    width={22}
                  />
                  <span className="percentage">
                  {(100 - 
    ((companyReviewData?.positive_percentage || 0) + 
     (companyReviewData?.negative_percentage || 0))
  ).toFixed(2)}%
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default CompanyFilter;
